import { TagIcon } from '@heroicons/react/24/outline';
import { Box, Group, Loader, Tabs, Text } from '@mantine/core';
import { TechnologyExperience } from '../../../../../models/technologyExperience.model';
import { PersonTechnology } from '../../../../../types/technology';
import { CategorizedSkills } from './CategorizedSkills';
import { SkillCloud } from './SkillCloud';

interface SkillsTabsProps {
  technologies: PersonTechnology[];
  technologyExperience: TechnologyExperience[];
  loading: boolean;
  defaultView?: 'cloud' | 'categories';
}

export function SkillsTabs({ technologies, technologyExperience, loading, defaultView = 'cloud' }: SkillsTabsProps) {
  return (
    <Box>
      <Group mb="xs">
        <TagIcon width={18} />
        <Text fw={600} size="md">Skills & Technologies</Text>
      </Group>

      {loading ? (
        <Box py="md" style={{ display: 'flex', justifyContent: 'center' }}>
          <Loader size="sm" />
        </Box>
      ) : technologies.length === 0 ? (
        <Text size="sm" c="dimmed" fs="italic">
          No skills and technologies found.
        </Text>
      ) : (
        <Tabs defaultValue={defaultView}>
          <Tabs.List>
            <Tabs.Tab value="cloud">Skill Cloud</Tabs.Tab>
            <Tabs.Tab value="categories">By Category</Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="cloud" pt="xs">
            <SkillCloud technologies={technologies} technologyExperience={technologyExperience} />
          </Tabs.Panel>

          <Tabs.Panel value="categories" pt="xs">
            <CategorizedSkills technologies={technologies} technologyExperience={technologyExperience} />
          </Tabs.Panel>
        </Tabs>
      )}
    </Box>
  );
}

